import React, { useEffect, useState } from 'react'
import img1 from '../../assets/images/signin-image.jpg'
import '../../assets/css/login-style.css'
import { Link, useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { LoginRequest, useGetCaptchaQuery, useLoginMutation } from '../../Redux/Apis/authApi'
import { setCredentials } from '../../Redux/Slices/authSlice'
import { useAuth } from '../../Redux/hooks/useAuth'

export const Login = () => {
    const navigate = useNavigate()
    const auth = useAuth()
    const [passwordShown, setPasswordShown] = useState(false);
    useEffect(() => {
        if (auth.user) navigate('/')
    })

    const dispatch = useDispatch()
    
    const [login, { isLoading }] = useLoginMutation()
    const [refresh, setRefresh ] = useState(1)
    const [errorMsg, setErrorMsg] = useState<any>(false)
    const [type, setType] = useState("first")

    const { data } = useGetCaptchaQuery({refresh})
    const getCaptcha = () =>  {
        setRefresh((prev) => prev + 1)
    }

    const togglePassword = () => {
        setPasswordShown(!passwordShown);
    };

    const [formState, setFormState] = useState<LoginRequest>({
        username: '',
        password: '',
        captcha: '',
        code: '',
    })

    const handleChange = ({ target: { name, value },} : React.ChangeEvent<HTMLInputElement> ) =>
        setFormState((prev) => ({ ...prev, [name]: value }))

    const onSubmit = async (e : React.FormEvent) => {
        e.preventDefault()
        try {
            if(type === "first"){
                delete formState.code
                const user = await login(formState).unwrap()
                if(user.token){
                    dispatch(setCredentials(user))
                    navigate('/') 
                }
                setType("otp")
                setErrorMsg(false) 
            }else{
                const user = await login(formState).unwrap()
                dispatch(setCredentials(user))
                navigate('/')
            }
            
        } catch (err:any){
            // console.log(err);
            getCaptcha();
            const message = !err.data ? '' : Array.isArray(err.data.message) ? err.data.message[0] : err.data.message
            setErrorMsg(message)                                     
        }
    }

    return (
        <div id='login-page' className='py-md-5 py-2'>
            <section className="sign-in my-md-5">
                <div className="container">
                    <div className="signin-content">
                        <div className="signin-image text-center">
                            <figure className='d-none d-sm-block'>
                                <img src={img1} className='img-fluid' alt="login"/>
                            </figure>
                            
                            <a href='https://linket.me' className='btn btn-outline-primary me-2 mb-2'>بازگشت به سایت</a>
                            <Link to="/signup" className="btn btn-warning mb-2">حساب کاربری ندارید؟</Link>
                        </div>

                        <div className="signin-form">
                            <h3 className="form-title">پنل مدیریت لینکِت</h3>
                            <h4 className="form-title">ورود </h4>
                            {errorMsg && <div className="alert alert-danger" role="alert">
                                {errorMsg}
                            </div>}
                            <form className="register-form" id="login-form" onSubmit={onSubmit}>
                                {type === "otp" ? 
                                <div className="form-group">
                                    <label htmlFor="user_code"><i className="zmdi zmdi-code-smartphone"></i></label>
                                    <input type="text" value={formState.code} onChange={handleChange} name="code" id="user_code" placeholder="کد ارسالی"  maxLength={6}/>
                                </div>
                                : 
                                <>
                                <div className="form-group">
                                    <label htmlFor="user_name"><i className="zmdi zmdi-account material-icons-name"></i></label>
                                    <input type="text" value={formState.username} onChange={handleChange} name="username" id="user_name" placeholder="شماره موبایل"/>
                                </div>
                                <div className="form-group mb-0">
                                    <label htmlFor="your_pass"><i className="zmdi zmdi-lock"></i></label>
                                    <input type={passwordShown ? "text" : "password"} value={formState.password} onChange={handleChange} name="password" id="your_pass" placeholder="رمز عبور"/>
                                    <button className="btn btn-outline-light border-0" onClick={togglePassword} type="button" id="show-pass"><i className="zmdi zmdi-eye text-secondary"></i></button>
                                </div>
                                <div className='text-end mb-4 mt-0 pt-1'>
                                <Link to="/reset-pass" className="link-primary link-offset-2 link-underline-opacity-25 link-underline-opacity-100-hover fw-light" >رمز عبور خود را فراموش کرده اید؟</Link>
                                </div>

                                <div className='form-group d-flex justify-content-center '>
                                    <div onClick={getCaptcha} className="text-center mb-2" dangerouslySetInnerHTML={{ __html: data?.data! }}></div>
                                    <button className="btn btn-outline-secondary border border-secondary-subtle" onClick={getCaptcha} type="button"><i className="zmdi zmdi-refresh-alt"></i></button>
                                </div>
                                <div className="form-group">
                                    <label htmlFor="your_captcha"><i className="zmdi zmdi-code"></i></label>
                                    <input type="text" name="captcha" value={formState.captcha} id='your_captcha' onChange={handleChange} placeholder="کد تصویر بالا" maxLength={4} />
                                </div>
                                </> 
                                }
                                <div className="form-group form-button">
                                    <input type="submit" disabled={isLoading} name="signin" id="signin" className="btn btn-primary form-submit" value="ورود"/>
                                </div>
                            </form>
                            
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}